import { render } from "./statsHome.vue?vue&type=template&id=6ed7668a&scoped=true"
import script from "./statsHome.vue?vue&type=script&lang=js"
export * from "./statsHome.vue?vue&type=script&lang=js"

import "./statsHome.vue?vue&type=style&index=0&id=6ed7668a&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed7668a"]])

export default __exports__